var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilePic1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9997 20.2313C21.7845 20.2313 26.6663 21.1713 26.6663 24.798C26.6663 28.426 21.7525 29.3327 15.9997 29.3327C10.2162 29.3327 5.33301 28.3927 5.33301 24.766C5.33301 21.1379 10.2469 20.2313 15.9997 20.2313ZM15.9997 2.66602C19.9185 2.66602 23.0583 5.80471 23.0583 9.72075C23.0583 13.6368 19.9185 16.7768 15.9997 16.7768C12.0822 16.7768 8.94103 13.6368 8.94103 9.72075C8.94103 5.80471 12.0822 2.66602 15.9997 2.66602Z",
    fill: "#F9A973"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic1);
export default __webpack_public_path__ + "static/media/ProfilePic1.5f13455a09440fca4554edae760b7519.svg";
export { ForwardRef as ReactComponent };